import {jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment} from "react/jsx-runtime";import {ExpandMore, LockOpen} from '@mui/icons-material'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import graphql from 'babel-plugin-relay/macro'
import {useFragment} from 'react-relay'


import useAtmosphere from '../hooks/useAtmosphere'
import {PALETTE} from '../styles/paletteV3'
import {Menu} from '../ui/Menu/Menu'
import {MenuContent} from '../ui/Menu/MenuContent'
import setPreferredTeamId from '../utils/relay/setPreferredTeamId'
import NewMeetingTeamPickerAvatars from './NewMeetingTeamPickerAvatars'








const NewMeetingTeamPicker = (props) => {
  const {selectedTeamRef, teamsRef, onSelectTeam, onShareToOrg} = props

  const atmosphere = useAtmosphere()

  const handleSelectTeam = (teamId) => {
    setPreferredTeamId(atmosphere, teamId)
    onSelectTeam(teamId)
  }

  const selectedTeam = useFragment(
    graphql`
      fragment NewMeetingTeamPicker_selectedTeam on Team {
        ...NewMeetingTeamPickerAvatars_team
        name
        organization {
          name
        }
      }
    `,
    selectedTeamRef
  )

  const teams = useFragment(
    graphql`
      fragment NewMeetingTeamPicker_teams on Team @relay(plural: true) {
        ...SelectTeamDropdown_teams
        id
        name
      }
    `,
    teamsRef
  )

  const {name} = selectedTeam

  return (
    _jsx(Menu, {
      trigger: 
        _jsxs('div', { className: "group flex cursor-pointer items-center rounded-md bg-slate-200 p-2 hover:bg-slate-300"       , children: [
          _jsx('div', { className: "p-2", children: 
            _jsx(NewMeetingTeamPickerAvatars, { teamRef: selectedTeam,} )
          })
          , _jsxs('div', { className: "grow pl-2" , children: [
            _jsx('div', { className: "text-sm leading-4" , children: "Team"})
            , _jsx('div', { className: "font-semibold text-xl leading-5"  , children: name})
          ]})
          , _jsx('div', { className: "s-6 p-2 pl-0"  , children: 
            _jsx(ExpandMore, { className: "text-4xl text-slate-600 transition-transform group-data-[state=open]:rotate-180"   ,} )
          })
        ]})
      ,
 children: 
      _jsx(MenuContent, { children: 
        _jsx('div', { className: "w-[var(--radix-dropdown-menu-trigger-width)]", children: 
          onShareToOrg ? (
            _jsxs('div', { className: "w-[352px] p-4" , children: [
              _jsxs('div', { children: ["This custom activity is private to the "
                       , _jsx('b', { children: selectedTeam.name}), " team."
              ]})
              , _jsx('br', {} )
              , _jsxs('div', { children: ["As a member of the team you can share this activity with other teams at the"
                               , ' '
                , _jsx('b', { children: selectedTeam.organization.name}), " organization so that they can also use the activity."

              ]})
              , _jsxs('button', {
                onClick: onShareToOrg,
                className: 
                  'mt-4 flex w-max cursor-pointer items-center rounded-full border border-slate-400 border-solid bg-white px-3 py-2 text-center font-sans font-semibold text-slate-700 text-sm hover:bg-slate-100'
                ,
 children: [
                _jsx(LockOpen, { style: {marginRight: '8px', color: PALETTE.SLATE_600},} ), "Allow other teams to use this activity"

              ]})
            ]})
          ) : (
            _jsxs(_Fragment, { children: [
              _jsx(DropdownMenu.Label, { className: "px-3 py-2 font-semibold text-base"   , children: "Select Team:"

              })
              , _jsx(DropdownMenu.Separator, { className: "border-slate-300 border-b" ,} )
              , _jsx('div', { className: "py-2", children: 
                teams.map((team) => {
                  return (
                    _jsx(DropdownMenu.Item, {

                      className: "px-3 py-1 text-base outline-hidden hover:bg-slate-200"    ,
                      onClick: () => {
                        handleSelectTeam(team.id)
                      },
 children: 
                      team.name
                    }, team.id)
                  )
                })
              })
            ]})
          )
        })
      })
    })
  )
}

export default NewMeetingTeamPicker
